import { useLanguage } from '@/contexts/LanguageContext';
import LanguageSelector from './LanguageSelector';
import logoImg from '@/assets/logo-salzburg-taxi.png?format=webp&quality=80';
import { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import LocalizedLink from './LocalizedLink';
import { stripLangPrefix } from '@/hooks/useLocalizedPath';

const SiteHeader = () => {
  const { t } = useLanguage();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const cleanPath = stripLangPrefix(location.pathname);

  const links = [
    { href: '/', label: t.nav.home },
    { href: '/services', label: t.nav.services },
    { href: '/transfers', label: t.nav.transfers },
    { href: '/tours', label: t.nav.tours },
    { href: '/fleet', label: t.nav.fleet },
    { href: '/booking', label: t.nav.booking },
  ];

  return (
    <header className="sticky top-0 z-50 bg-secondary border-b border-secondary/80 backdrop-blur-md">
      <div className="container flex items-center justify-between h-20 md:h-28">
        <LocalizedLink to="/" className="flex items-center gap-3">
          <img src={logoImg} alt="Taxi Salzburg Logo" className="h-24 md:h-32 object-contain" />
        </LocalizedLink>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-5">
          {links.map((l) => (
            <LocalizedLink
              key={l.href}
              to={l.href}
              className={`text-sm font-medium transition-colors ${cleanPath === l.href ? 'text-primary' : 'text-secondary-foreground/80 hover:text-primary'}`}
            >
              {l.label}
            </LocalizedLink>
          ))}
          <LanguageSelector />
          <a href="tel:+436606521071" dir="ltr" className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-gold text-primary-foreground font-semibold text-sm hover:scale-105 transition-transform">
            <Phone className="w-4 h-4" /> +43 660 6521071
          </a>
        </nav>

        {/* Mobile */}
        <div className="flex lg:hidden items-center gap-3">
          <LanguageSelector />
          <button onClick={() => setMobileOpen(!mobileOpen)} className="text-secondary-foreground">
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="lg:hidden bg-secondary border-t border-secondary-foreground/10 pb-4">
          {links.map((l) => (
            <LocalizedLink
              key={l.href}
              to={l.href}
              onClick={() => setMobileOpen(false)}
              className={`block px-6 py-3 text-sm transition-colors ${cleanPath === l.href ? 'text-primary font-semibold' : 'text-secondary-foreground/80 hover:text-primary'}`}
            >
              {l.label}
            </LocalizedLink>
          ))}
          <a href="tel:+436606521071" dir="ltr" className="block mx-6 mt-3 text-center px-6 py-3 rounded-full bg-gradient-gold text-primary-foreground font-semibold text-sm">
            📞 +43 660 6521071
          </a>
        </nav>
      )}
    </header>
  );
};

export default SiteHeader;
